module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-seam-f57b76d5.svg";